/**
 * Corrects the drawing (scaling and positioning) of createjs.DOMElement according to the device pixel ratio.
 * We need to take this into account as we actually oversize the canvas for >1 dpr displays (e.g. Retina displays).
 * Extends createjs method (https://createjs.com/docs/easeljs/files/easeljs_display_DOMElement.js.html#l264).
 * 
 * Added/ Changed code has been marked with "deviates from CreateJS implementation".
 */
export default class DprDOMElement extends createjs.DOMElement {
    _handleDrawEnd() {
        var o = this.htmlElement;
        if (!o) {
            return;
        }
        var style = o.style;

        var props = this.getConcatenatedDisplayProps(this._props), mtx = props.matrix;

        var visibility = props.visible ? "visible" : "hidden";
        if (visibility != style.visibility) { style.visibility = visibility; }
        if (!props.visible) {
            return;
        }

        var oldProps = this._oldProps, oldMtx = oldProps && oldProps.matrix;
        var n = 10000; // precision

        if (!oldMtx || !oldMtx.equals(mtx)) {
            const dpr = window.devicePixelRatio;

            // --- Deviates from CreateJS implementation (BEGIN) ---

            // Compensate scale and translate (position) with dpr.
            const scaleX = ((mtx.a * n | 0) / n) / dpr; // '| 0' uses a Bitwise OR expression.
            const skewY = (mtx.b * n | 0) / n;
            const skewX = (mtx.c * n | 0) / n;
            const scaleY = ((mtx.d * n | 0) / n) / dpr;
            const translateX = (mtx.tx + 0.5 | 0) / dpr;
            const translateY = (mtx.ty + 0.5 | 0) / dpr;

            const matrixWithoutUnit = `matrix(${scaleX}, ${skewY}, ${skewX}, ${scaleY}, ${translateX}, ${translateY})`;
            const matrixWithUnit = `matrix(${scaleX}, ${skewY}, ${skewX}, ${scaleY}, ${translateX}px, ${translateY}px)`;

            style.transform = style.WebkitTransform = style.OTransform = style.msTransform = matrixWithoutUnit;
            style.MozTransform = matrixWithUnit; // MozTransform needs 'px' to be specified.

            // --- Deviates from CreateJS implementation (END) ---

            if (!oldProps) {
                oldProps = this._oldProps = new createjs.DisplayProps(true, null);
            }
            oldProps.matrix.copy(mtx);
        }

        if (oldProps.alpha != props.alpha) {
            style.opacity = "" + (props.alpha * n | 0) / n;
            oldProps.alpha = props.alpha;
        }
    }
}